exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-progress-path{display:inline-block\n}\n.vue-progress-path path{fill:none;stroke-width:6;-webkit-transition:stroke-dashoffset .3s ease-in-out;transition:stroke-dashoffset .3s ease-in-out\n}\n.vue-progress-path .background{stroke:#ddd\n}\n.vue-progress-path .progress{stroke:#40b883\n}\n.vue-progress-path.indeterminate path{-webkit-transition:none;transition:none\n}", ""]);

// exports
